// Configuration centralisée pour les informations de contact
// Modifiez ces valeurs pour changer les informations dans tous les composants

export const CONTACT_CONFIG = {
  // Numéro de téléphone WhatsApp
  phoneNumber: "+32 460207686",
  
  // Email de contact
  email: "contact@tvluxo.com",
  
  // URL WhatsApp complète
  whatsappUrl: "https://wa.me/32460207686",
  
  // Nom de l'entreprise
  companyName: "TVLUXO",
  
  // URL du site web
  websiteUrl: "https://tvluxo.com"
};

// Fonction utilitaire pour formater le numéro de téléphone
export const formatPhoneNumber = (phoneNumber) => {
  return phoneNumber.replace(/\s/g, '');
};

// Fonction utilitaire pour créer l'URL WhatsApp
export const createWhatsAppUrl = (phoneNumber, message = "") => {
  const cleanNumber = formatPhoneNumber(phoneNumber);
  return `https://wa.me/${cleanNumber}${message ? `?text=${encodeURIComponent(message)}` : ''}`;
};
